export default __webpack_public_path__ + "static/media/SCDream-Medium.ae5ee493.otf";